import React from 'react'
import TBCScene from './TBCScene'
import Measure from 'react-measure'

export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      is_ended: false,
      isTriggerRefresh: false,
      scene: 0,
      scenes: props.scenes.scene || [],
      width: 0,
      height: 0,
    }
  }


  resetScenes(scenes)
  {
    this.setState({
      scene: 1000,
      isTriggerRefresh: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          is_ended: false,
          scene: 0,
          isTriggerRefresh: false,
          scenes: scenes.scene || [],
        })
      }, 60)
    })
  }


  nextScene(is_ended_callback)
  {
    console.log('====== NEXT SCENE ...');
    if (this.state.scenes.length > this.state.scene + 1)
    {
      this.setState({scene: this.state.scene + 1})
      this.setState({is_ended: false});
      window.history.pushState('forward', null, null);
    }
    else
    {
      this.setState({is_ended: true}, () => {
        if (is_ended_callback) {
          is_ended_callback();
        }
      });
    }
  }

  prevScene()
  {
    if (this.state.scene <= 0) {
      return;
    }
    console.log('====== PREV SCENE ...');
    this.setState({scene: this.state.scene - 1})
    this.setState({is_ended: false});
  }

  currentScene()
  {
    return this.state.scene;
  }

  render() {
    return (
        <Measure
            bounds
            onResize={contentRect => {
              if (typeof window != null)
              {
                var ratio = window.innerWidth / window.innerHeight * 100;
                console.log("DIM...", window.innerWidth, window.innerHeight, window.innerWidth / window.innerHeight * 100);
                if (ratio < 56.25)
                {
                  var width = window.innerWidth;
                  var height = width * 16 / 9;
                  this.setState({
                    dimensions: contentRect.bounds,
                    width: width,
                    height: height,
                  })
                  console.log("DIM1", width, height, window.innerWidth);
                }
                else
                {
                  var width = contentRect.bounds.height / 16 * 9;
                  var height = contentRect.bounds.height;
                  this.setState({
                    dimensions: contentRect.bounds,
                    width: width,
                    height: height,
                  })
                  console.log("DIM2", width, height, window.innerWidth);
                }
              }
            }}
        >
          {
            ({ measureRef }) => (
                <div
                    ref={measureRef}
                    style={{
                      display: `block`,
                      textAlign: `center`,
                      position: `absolute`,
                      left: 0,
                      top: 0,
                      bottom: 0,
                      right: 0,
                      backgroundColor: '#000',
                    }}>
                  <div style={{
                    width: this.state.width,
                    position: `relative`,
                    height: this.state.height,
                    display: `inline-block`,
                  }}>
                    <div style={{
                      width: `100%`,
                      left: 0,
                      top: 0,
                      position: `absolute`,
                      height: `100%`,
                    }}>
                      {
                        this.props.children ? this.props.children : this.state.scenes.map((scene, i) => {
                          return (
                              <TBCScene {...this.props}
                                        is_ended={this.state.is_ended}
                                        episodeName={this.props.episodeName}
                                        nextScene={(is_ended_callback) => {this.nextScene(is_ended_callback)}}
                                        prevScene={() => {this.prevScene()}}
                                        is_active={i === this.state.scene}
                                        isTriggerRefresh={this.state.isTriggerRefresh}
                                        key={i}
                                        scene={this.state.scenes[i]}/>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
            )}
        </Measure>
    )
  }
}